import ability from './ability'
import { getUserData } from '@/auth/utils'

export const canNavigate = to => {
  if (to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))) {
    return true
  }

  // Client: abilities ile yetkilendirilmiş kullanıcı /about (Bize Ulaşın) sayfasına girebilsin
  const isAbout = to.matched.some(route => route.name === 'CompanyView' || route.path === '/about')
  if (isAbout) {
    const userData = getUserData()
    if (userData?.role === 'client' && Array.isArray(userData.ability) && userData.ability.length) {
      return true
    }
  }

  return false
}

export const _ = undefined
